var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.mode === "DESIGN"
      ? _c(
          "div",
          { staticClass: "my-date-range-picker disabled-box max-width" },
          [
            _c("el-date-picker", {
              attrs: {
                size: "small",
                type: _vm.type,
                "start-placeholder": _vm.placeholder[0],
                "end-placeholder": _vm.placeholder[1],
                "default-time": ["00:00:00", "23:59:59"],
                "prefix-icon": "el-icon-date",
              },
              model: {
                value: _vm._value,
                callback: function ($$v) {
                  _vm._value = $$v
                },
                expression: "_value",
              },
            }),
            _vm.totalType == "day" || _vm.totalType == "hour"
              ? _c("div", { staticClass: "total-time-con" }, [
                  _c("span", { staticClass: "text" }, [_vm._v("累计时间：")]),
                  _c("span", { staticClass: "time" }, [
                    _vm._v(_vm._s(_vm.totalTime)),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          [
            [
              !_vm.readerMode || _vm.perm === "E"
                ? _c(
                    "div",
                    { staticClass: "my-date-range-picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          "value-format": _vm.format,
                          type: _vm.type,
                          disabled: _vm.perm === "R",
                          "start-placeholder": _vm.placeholder[0],
                          "end-placeholder": _vm.placeholder[1],
                          "prefix-icon": "el-icon-date",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm._value,
                          callback: function ($$v) {
                            _vm._value = $$v
                          },
                          expression: "_value",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "form-item-text" },
                    [
                      _vm.value.length == 2
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(_vm.value[0] + " ~ " + _vm.value[1]) +
                                " "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
            ],
            _vm.totalType == "day" || _vm.totalType == "hour"
              ? _c("div", { staticClass: "total-time-con" }, [
                  _c("span", { staticClass: "text" }, [_vm._v("累计时间：")]),
                  _c("span", { staticClass: "time" }, [
                    _vm._v(_vm._s(_vm.totalTime)),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }